// source: pbtypes/vehicle/infrastructure/flight_deck/flight.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var pbtypes_vehicle_infrastructure_flight_deck_comment_pb = require('../../../../pbtypes/vehicle/infrastructure/flight_deck/comment_pb.js');
goog.object.extend(proto, pbtypes_vehicle_infrastructure_flight_deck_comment_pb);
var pbtypes_vehicle_infrastructure_flight_deck_media_pb = require('../../../../pbtypes/vehicle/infrastructure/flight_deck/media_pb.js');
goog.object.extend(proto, pbtypes_vehicle_infrastructure_flight_deck_media_pb);
var pbtypes_vehicle_infrastructure_flight_deck_ucon_pb = require('../../../../pbtypes/vehicle/infrastructure/flight_deck/ucon_pb.js');
goog.object.extend(proto, pbtypes_vehicle_infrastructure_flight_deck_ucon_pb);
var pbtypes_gen_cloud_config_client_type_pb = require('../../../../pbtypes/gen/cloud_config/client_type_pb.js');
goog.object.extend(proto, pbtypes_gen_cloud_config_client_type_pb);
var pbtypes_infrastructure_drivers_attachment_manager_attachment_manager_pb = require('../../../../pbtypes/infrastructure/drivers/attachment_manager/attachment_manager_pb.js');
goog.object.extend(proto, pbtypes_infrastructure_drivers_attachment_manager_attachment_manager_pb);
var pbtypes_tools_cloud_api_landing_results_pb = require('../../../../pbtypes/tools/cloud_api/landing_results_pb.js');
goog.object.extend(proto, pbtypes_tools_cloud_api_landing_results_pb);
var pbtypes_tools_cloud_api_flight_pb = require('../../../../pbtypes/tools/cloud_api/flight_pb.js');
goog.object.extend(proto, pbtypes_tools_cloud_api_flight_pb);
goog.exportSymbol('proto.flight_deck.Flight', null, global);
goog.exportSymbol('proto.flight_deck.Flight.IngestStatus', null, global);
goog.exportSymbol('proto.flight_deck.FlightDebugFile', null, global);
goog.exportSymbol('proto.flight_deck.FlightFailureMode', null, global);
goog.exportSymbol('proto.flight_deck.FlightFailureMode.ModesCase', null, global);
goog.exportSymbol('proto.flight_deck.FlightFailures', null, global);
goog.exportSymbol('proto.flight_deck.FlightFaults', null, global);
goog.exportSymbol('proto.flight_deck.FlightLogDirUpdate', null, global);
goog.exportSymbol('proto.flight_deck.FlightLogTruncateRequest', null, global);
goog.exportSymbol('proto.flight_deck.FlightMediaStatus', null, global);
goog.exportSymbol('proto.flight_deck.FlightMediaStatus.EditorReadiness', null, global);
goog.exportSymbol('proto.flight_deck.FlightMediaStatus.EditorReadiness.Type', null, global);
goog.exportSymbol('proto.flight_deck.FlightMediaStatus.MediaProgress', null, global);
goog.exportSymbol('proto.flight_deck.FlightMediaStatus.MediaProgress.Type', null, global);
goog.exportSymbol('proto.flight_deck.FlightModemStatesInfo', null, global);
goog.exportSymbol('proto.flight_deck.FlightStats', null, global);
goog.exportSymbol('proto.flight_deck.Flights', null, global);
goog.exportSymbol('proto.flight_deck.LogDeletionPolicy', null, global);
goog.exportSymbol('proto.flight_deck.UpdateLogDeletionPolicyRequest', null, global);
goog.exportSymbol('proto.flight_deck.UpdateLogDeletionPolicyResponse', null, global);
goog.exportSymbol('proto.flight_deck.UpdateLogDeletionPolicyResult', null, global);
goog.exportSymbol('proto.flight_deck.UpdateLogDeletionPolicyResult.Result', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.FlightDebugFile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.FlightDebugFile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.FlightDebugFile.displayName = 'proto.flight_deck.FlightDebugFile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.Flight = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_deck.Flight.repeatedFields_, null);
};
goog.inherits(proto.flight_deck.Flight, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.Flight.displayName = 'proto.flight_deck.Flight';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.FlightStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.FlightStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.FlightStats.displayName = 'proto.flight_deck.FlightStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.FlightModemStatesInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_deck.FlightModemStatesInfo.repeatedFields_, null);
};
goog.inherits(proto.flight_deck.FlightModemStatesInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.FlightModemStatesInfo.displayName = 'proto.flight_deck.FlightModemStatesInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.Flights = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_deck.Flights.repeatedFields_, null);
};
goog.inherits(proto.flight_deck.Flights, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.Flights.displayName = 'proto.flight_deck.Flights';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.FlightMediaStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_deck.FlightMediaStatus.repeatedFields_, null);
};
goog.inherits(proto.flight_deck.FlightMediaStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.FlightMediaStatus.displayName = 'proto.flight_deck.FlightMediaStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.FlightMediaStatus.MediaProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.FlightMediaStatus.MediaProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.FlightMediaStatus.MediaProgress.displayName = 'proto.flight_deck.FlightMediaStatus.MediaProgress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.FlightMediaStatus.EditorReadiness = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.FlightMediaStatus.EditorReadiness, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.FlightMediaStatus.EditorReadiness.displayName = 'proto.flight_deck.FlightMediaStatus.EditorReadiness';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.FlightLogDirUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.FlightLogDirUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.FlightLogDirUpdate.displayName = 'proto.flight_deck.FlightLogDirUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.FlightLogTruncateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.FlightLogTruncateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.FlightLogTruncateRequest.displayName = 'proto.flight_deck.FlightLogTruncateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.FlightFailures = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_deck.FlightFailures.repeatedFields_, null);
};
goog.inherits(proto.flight_deck.FlightFailures, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.FlightFailures.displayName = 'proto.flight_deck.FlightFailures';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.FlightFailureMode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.flight_deck.FlightFailureMode.oneofGroups_);
};
goog.inherits(proto.flight_deck.FlightFailureMode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.FlightFailureMode.displayName = 'proto.flight_deck.FlightFailureMode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.FlightFaults = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_deck.FlightFaults.repeatedFields_, null);
};
goog.inherits(proto.flight_deck.FlightFaults, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.FlightFaults.displayName = 'proto.flight_deck.FlightFaults';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.LogDeletionPolicy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.LogDeletionPolicy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.LogDeletionPolicy.displayName = 'proto.flight_deck.LogDeletionPolicy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.UpdateLogDeletionPolicyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_deck.UpdateLogDeletionPolicyRequest.repeatedFields_, null);
};
goog.inherits(proto.flight_deck.UpdateLogDeletionPolicyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.UpdateLogDeletionPolicyRequest.displayName = 'proto.flight_deck.UpdateLogDeletionPolicyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.UpdateLogDeletionPolicyResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.UpdateLogDeletionPolicyResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.UpdateLogDeletionPolicyResult.displayName = 'proto.flight_deck.UpdateLogDeletionPolicyResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.UpdateLogDeletionPolicyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_deck.UpdateLogDeletionPolicyResponse.repeatedFields_, null);
};
goog.inherits(proto.flight_deck.UpdateLogDeletionPolicyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.UpdateLogDeletionPolicyResponse.displayName = 'proto.flight_deck.UpdateLogDeletionPolicyResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.FlightDebugFile.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.FlightDebugFile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.FlightDebugFile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightDebugFile.toObject = function(includeInstance, msg) {
  var f, obj = {
path: jspb.Message.getFieldWithDefault(msg, 1, ""),
size: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.FlightDebugFile}
 */
proto.flight_deck.FlightDebugFile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.FlightDebugFile;
  return proto.flight_deck.FlightDebugFile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.FlightDebugFile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.FlightDebugFile}
 */
proto.flight_deck.FlightDebugFile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.FlightDebugFile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.FlightDebugFile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.FlightDebugFile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightDebugFile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSize();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.flight_deck.FlightDebugFile.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.FlightDebugFile} returns this
 */
proto.flight_deck.FlightDebugFile.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double size = 2;
 * @return {number}
 */
proto.flight_deck.FlightDebugFile.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.FlightDebugFile} returns this
 */
proto.flight_deck.FlightDebugFile.prototype.setSize = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_deck.Flight.repeatedFields_ = [5,6,14,18,24,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.Flight.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.Flight.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.Flight} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.Flight.toObject = function(includeInstance, msg) {
  var f, obj = {
flightId: jspb.Message.getFieldWithDefault(msg, 1, ""),
vehicleId: jspb.Message.getFieldWithDefault(msg, 15, ""),
deleted: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
needsUpload: jspb.Message.getBooleanFieldWithDefault(msg, 26, false),
uploadConfig: (f = msg.getUploadConfig()) && pbtypes_vehicle_infrastructure_flight_deck_ucon_pb.UploadConfig.toObject(includeInstance, f),
preventLogDeletion: jspb.Message.getBooleanFieldWithDefault(msg, 36, false),
failures: (f = msg.getFailures()) && proto.flight_deck.FlightFailures.toObject(includeInstance, f),
takeoffUserId: jspb.Message.getFieldWithDefault(msg, 16, ""),
takeoffClientType: jspb.Message.getFieldWithDefault(msg, 30, 0),
takeoffPhoneId: jspb.Message.getFieldWithDefault(msg, 17, ""),
takeoffDockId: jspb.Message.getFieldWithDefault(msg, 31, ""),
takeoffUtime: jspb.Message.getFieldWithDefault(msg, 3, 0),
landingUtime: jspb.Message.getFieldWithDefault(msg, 4, 0),
takeoffUclock: jspb.Message.getFieldWithDefault(msg, 7, 0),
landingUclock: jspb.Message.getFieldWithDefault(msg, 8, 0),
imagesList: jspb.Message.toObjectList(msg.getImagesList(),
    pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.toObject, includeInstance),
videosList: jspb.Message.toObjectList(msg.getVideosList(),
    pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.toObject, includeInstance),
audioList: jspb.Message.toObjectList(msg.getAudioList(),
    pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.toObject, includeInstance),
logFilesList: jspb.Message.toObjectList(msg.getLogFilesList(),
    pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.toObject, includeInstance),
genericFilesList: jspb.Message.toObjectList(msg.getGenericFilesList(),
    pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.toObject, includeInstance),
debugFilesList: jspb.Message.toObjectList(msg.getDebugFilesList(),
    proto.flight_deck.FlightDebugFile.toObject, includeInstance),
ingestStatus: jspb.Message.getFieldWithDefault(msg, 19, 0),
comment: (f = msg.getComment()) && pbtypes_vehicle_infrastructure_flight_deck_comment_pb.Comment.toObject(includeInstance, f),
stats: (f = msg.getStats()) && proto.flight_deck.FlightStats.toObject(includeInstance, f),
releaseKey: jspb.Message.getFieldWithDefault(msg, 21, ""),
deployCommit: jspb.Message.getFieldWithDefault(msg, 22, ""),
takeoffFlightDeckRun: jspb.Message.getFieldWithDefault(msg, 28, 0),
landingFlightDeckRun: jspb.Message.getFieldWithDefault(msg, 29, 0),
landingResults: (f = msg.getLandingResults()) && pbtypes_tools_cloud_api_landing_results_pb.LandingResults.toObject(includeInstance, f),
gimbalId: jspb.Message.getFieldWithDefault(msg, 34, ""),
vehicleAttachmentInfo: (f = msg.getVehicleAttachmentInfo()) && pbtypes_infrastructure_drivers_attachment_manager_attachment_manager_pb.VehicleAttachmentInfo.toObject(includeInstance, f),
flightModemStates: (f = msg.getFlightModemStates()) && proto.flight_deck.FlightModemStatesInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.Flight}
 */
proto.flight_deck.Flight.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.Flight;
  return proto.flight_deck.Flight.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.Flight} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.Flight}
 */
proto.flight_deck.Flight.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlightId(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleId(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleted(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNeedsUpload(value);
      break;
    case 27:
      var value = new pbtypes_vehicle_infrastructure_flight_deck_ucon_pb.UploadConfig;
      reader.readMessage(value,pbtypes_vehicle_infrastructure_flight_deck_ucon_pb.UploadConfig.deserializeBinaryFromReader);
      msg.setUploadConfig(value);
      break;
    case 36:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPreventLogDeletion(value);
      break;
    case 33:
      var value = new proto.flight_deck.FlightFailures;
      reader.readMessage(value,proto.flight_deck.FlightFailures.deserializeBinaryFromReader);
      msg.setFailures(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setTakeoffUserId(value);
      break;
    case 30:
      var value = /** @type {!proto.cloud_config.ClientType.Enum} */ (reader.readEnum());
      msg.setTakeoffClientType(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setTakeoffPhoneId(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setTakeoffDockId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTakeoffUtime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLandingUtime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTakeoffUclock(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLandingUclock(value);
      break;
    case 5:
      var value = new pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media;
      reader.readMessage(value,pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.deserializeBinaryFromReader);
      msg.addImages(value);
      break;
    case 6:
      var value = new pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media;
      reader.readMessage(value,pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.deserializeBinaryFromReader);
      msg.addVideos(value);
      break;
    case 14:
      var value = new pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media;
      reader.readMessage(value,pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.deserializeBinaryFromReader);
      msg.addAudio(value);
      break;
    case 18:
      var value = new pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media;
      reader.readMessage(value,pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.deserializeBinaryFromReader);
      msg.addLogFiles(value);
      break;
    case 24:
      var value = new pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media;
      reader.readMessage(value,pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.deserializeBinaryFromReader);
      msg.addGenericFiles(value);
      break;
    case 9:
      var value = new proto.flight_deck.FlightDebugFile;
      reader.readMessage(value,proto.flight_deck.FlightDebugFile.deserializeBinaryFromReader);
      msg.addDebugFiles(value);
      break;
    case 19:
      var value = /** @type {!proto.flight_deck.Flight.IngestStatus} */ (reader.readEnum());
      msg.setIngestStatus(value);
      break;
    case 12:
      var value = new pbtypes_vehicle_infrastructure_flight_deck_comment_pb.Comment;
      reader.readMessage(value,pbtypes_vehicle_infrastructure_flight_deck_comment_pb.Comment.deserializeBinaryFromReader);
      msg.setComment(value);
      break;
    case 13:
      var value = new proto.flight_deck.FlightStats;
      reader.readMessage(value,proto.flight_deck.FlightStats.deserializeBinaryFromReader);
      msg.setStats(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setReleaseKey(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeployCommit(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTakeoffFlightDeckRun(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLandingFlightDeckRun(value);
      break;
    case 32:
      var value = new pbtypes_tools_cloud_api_landing_results_pb.LandingResults;
      reader.readMessage(value,pbtypes_tools_cloud_api_landing_results_pb.LandingResults.deserializeBinaryFromReader);
      msg.setLandingResults(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setGimbalId(value);
      break;
    case 35:
      var value = new pbtypes_infrastructure_drivers_attachment_manager_attachment_manager_pb.VehicleAttachmentInfo;
      reader.readMessage(value,pbtypes_infrastructure_drivers_attachment_manager_attachment_manager_pb.VehicleAttachmentInfo.deserializeBinaryFromReader);
      msg.setVehicleAttachmentInfo(value);
      break;
    case 37:
      var value = new proto.flight_deck.FlightModemStatesInfo;
      reader.readMessage(value,proto.flight_deck.FlightModemStatesInfo.deserializeBinaryFromReader);
      msg.setFlightModemStates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.Flight.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.Flight.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.Flight} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.Flight.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFlightId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getDeleted();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getNeedsUpload();
  if (f) {
    writer.writeBool(
      26,
      f
    );
  }
  f = message.getUploadConfig();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      pbtypes_vehicle_infrastructure_flight_deck_ucon_pb.UploadConfig.serializeBinaryToWriter
    );
  }
  f = message.getPreventLogDeletion();
  if (f) {
    writer.writeBool(
      36,
      f
    );
  }
  f = message.getFailures();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      proto.flight_deck.FlightFailures.serializeBinaryToWriter
    );
  }
  f = message.getTakeoffUserId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getTakeoffClientType();
  if (f !== 0.0) {
    writer.writeEnum(
      30,
      f
    );
  }
  f = message.getTakeoffPhoneId();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getTakeoffDockId();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getTakeoffUtime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getLandingUtime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getTakeoffUclock();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getLandingUclock();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getImagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.serializeBinaryToWriter
    );
  }
  f = message.getVideosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.serializeBinaryToWriter
    );
  }
  f = message.getAudioList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.serializeBinaryToWriter
    );
  }
  f = message.getLogFilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.serializeBinaryToWriter
    );
  }
  f = message.getGenericFilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      24,
      f,
      pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media.serializeBinaryToWriter
    );
  }
  f = message.getDebugFilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.flight_deck.FlightDebugFile.serializeBinaryToWriter
    );
  }
  f = message.getIngestStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getComment();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      pbtypes_vehicle_infrastructure_flight_deck_comment_pb.Comment.serializeBinaryToWriter
    );
  }
  f = message.getStats();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.flight_deck.FlightStats.serializeBinaryToWriter
    );
  }
  f = message.getReleaseKey();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getDeployCommit();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getTakeoffFlightDeckRun();
  if (f !== 0) {
    writer.writeInt64(
      28,
      f
    );
  }
  f = message.getLandingFlightDeckRun();
  if (f !== 0) {
    writer.writeInt64(
      29,
      f
    );
  }
  f = message.getLandingResults();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      pbtypes_tools_cloud_api_landing_results_pb.LandingResults.serializeBinaryToWriter
    );
  }
  f = message.getGimbalId();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getVehicleAttachmentInfo();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      pbtypes_infrastructure_drivers_attachment_manager_attachment_manager_pb.VehicleAttachmentInfo.serializeBinaryToWriter
    );
  }
  f = message.getFlightModemStates();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      proto.flight_deck.FlightModemStatesInfo.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.flight_deck.Flight.IngestStatus = {
  NO_RECORDING_REQUESTED: 0,
  INGEST_PENDING: 1,
  INGEST_COMPLETE: 2,
  INGEST_FAILED: 3
};

/**
 * optional string flight_id = 1;
 * @return {string}
 */
proto.flight_deck.Flight.prototype.getFlightId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setFlightId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string vehicle_id = 15;
 * @return {string}
 */
proto.flight_deck.Flight.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setVehicleId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional bool deleted = 23;
 * @return {boolean}
 */
proto.flight_deck.Flight.prototype.getDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool needs_upload = 26;
 * @return {boolean}
 */
proto.flight_deck.Flight.prototype.getNeedsUpload = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setNeedsUpload = function(value) {
  return jspb.Message.setProto3BooleanField(this, 26, value);
};


/**
 * optional UploadConfig upload_config = 27;
 * @return {?proto.flight_deck.UploadConfig}
 */
proto.flight_deck.Flight.prototype.getUploadConfig = function() {
  return /** @type{?proto.flight_deck.UploadConfig} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_infrastructure_flight_deck_ucon_pb.UploadConfig, 27));
};


/**
 * @param {?proto.flight_deck.UploadConfig|undefined} value
 * @return {!proto.flight_deck.Flight} returns this
*/
proto.flight_deck.Flight.prototype.setUploadConfig = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.clearUploadConfig = function() {
  return this.setUploadConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Flight.prototype.hasUploadConfig = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional bool prevent_log_deletion = 36;
 * @return {boolean}
 */
proto.flight_deck.Flight.prototype.getPreventLogDeletion = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 36, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setPreventLogDeletion = function(value) {
  return jspb.Message.setProto3BooleanField(this, 36, value);
};


/**
 * optional FlightFailures failures = 33;
 * @return {?proto.flight_deck.FlightFailures}
 */
proto.flight_deck.Flight.prototype.getFailures = function() {
  return /** @type{?proto.flight_deck.FlightFailures} */ (
    jspb.Message.getWrapperField(this, proto.flight_deck.FlightFailures, 33));
};


/**
 * @param {?proto.flight_deck.FlightFailures|undefined} value
 * @return {!proto.flight_deck.Flight} returns this
*/
proto.flight_deck.Flight.prototype.setFailures = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.clearFailures = function() {
  return this.setFailures(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Flight.prototype.hasFailures = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional string takeoff_user_id = 16;
 * @return {string}
 */
proto.flight_deck.Flight.prototype.getTakeoffUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setTakeoffUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional cloud_config.ClientType.Enum takeoff_client_type = 30;
 * @return {!proto.cloud_config.ClientType.Enum}
 */
proto.flight_deck.Flight.prototype.getTakeoffClientType = function() {
  return /** @type {!proto.cloud_config.ClientType.Enum} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {!proto.cloud_config.ClientType.Enum} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setTakeoffClientType = function(value) {
  return jspb.Message.setProto3EnumField(this, 30, value);
};


/**
 * optional string takeoff_phone_id = 17;
 * @return {string}
 */
proto.flight_deck.Flight.prototype.getTakeoffPhoneId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setTakeoffPhoneId = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string takeoff_dock_id = 31;
 * @return {string}
 */
proto.flight_deck.Flight.prototype.getTakeoffDockId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setTakeoffDockId = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional int64 takeoff_utime = 3;
 * @return {number}
 */
proto.flight_deck.Flight.prototype.getTakeoffUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setTakeoffUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 landing_utime = 4;
 * @return {number}
 */
proto.flight_deck.Flight.prototype.getLandingUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setLandingUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 takeoff_uclock = 7;
 * @return {number}
 */
proto.flight_deck.Flight.prototype.getTakeoffUclock = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setTakeoffUclock = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 landing_uclock = 8;
 * @return {number}
 */
proto.flight_deck.Flight.prototype.getLandingUclock = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setLandingUclock = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated Media images = 5;
 * @return {!Array<!proto.flight_deck.Media>}
 */
proto.flight_deck.Flight.prototype.getImagesList = function() {
  return /** @type{!Array<!proto.flight_deck.Media>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media, 5));
};


/**
 * @param {!Array<!proto.flight_deck.Media>} value
 * @return {!proto.flight_deck.Flight} returns this
*/
proto.flight_deck.Flight.prototype.setImagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.flight_deck.Media=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.Media}
 */
proto.flight_deck.Flight.prototype.addImages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.flight_deck.Media, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.clearImagesList = function() {
  return this.setImagesList([]);
};


/**
 * repeated Media videos = 6;
 * @return {!Array<!proto.flight_deck.Media>}
 */
proto.flight_deck.Flight.prototype.getVideosList = function() {
  return /** @type{!Array<!proto.flight_deck.Media>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media, 6));
};


/**
 * @param {!Array<!proto.flight_deck.Media>} value
 * @return {!proto.flight_deck.Flight} returns this
*/
proto.flight_deck.Flight.prototype.setVideosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.flight_deck.Media=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.Media}
 */
proto.flight_deck.Flight.prototype.addVideos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.flight_deck.Media, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.clearVideosList = function() {
  return this.setVideosList([]);
};


/**
 * repeated Media audio = 14;
 * @return {!Array<!proto.flight_deck.Media>}
 */
proto.flight_deck.Flight.prototype.getAudioList = function() {
  return /** @type{!Array<!proto.flight_deck.Media>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media, 14));
};


/**
 * @param {!Array<!proto.flight_deck.Media>} value
 * @return {!proto.flight_deck.Flight} returns this
*/
proto.flight_deck.Flight.prototype.setAudioList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.flight_deck.Media=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.Media}
 */
proto.flight_deck.Flight.prototype.addAudio = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.flight_deck.Media, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.clearAudioList = function() {
  return this.setAudioList([]);
};


/**
 * repeated Media log_files = 18;
 * @return {!Array<!proto.flight_deck.Media>}
 */
proto.flight_deck.Flight.prototype.getLogFilesList = function() {
  return /** @type{!Array<!proto.flight_deck.Media>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media, 18));
};


/**
 * @param {!Array<!proto.flight_deck.Media>} value
 * @return {!proto.flight_deck.Flight} returns this
*/
proto.flight_deck.Flight.prototype.setLogFilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.flight_deck.Media=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.Media}
 */
proto.flight_deck.Flight.prototype.addLogFiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.flight_deck.Media, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.clearLogFilesList = function() {
  return this.setLogFilesList([]);
};


/**
 * repeated Media generic_files = 24;
 * @return {!Array<!proto.flight_deck.Media>}
 */
proto.flight_deck.Flight.prototype.getGenericFilesList = function() {
  return /** @type{!Array<!proto.flight_deck.Media>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_vehicle_infrastructure_flight_deck_media_pb.Media, 24));
};


/**
 * @param {!Array<!proto.flight_deck.Media>} value
 * @return {!proto.flight_deck.Flight} returns this
*/
proto.flight_deck.Flight.prototype.setGenericFilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 24, value);
};


/**
 * @param {!proto.flight_deck.Media=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.Media}
 */
proto.flight_deck.Flight.prototype.addGenericFiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 24, opt_value, proto.flight_deck.Media, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.clearGenericFilesList = function() {
  return this.setGenericFilesList([]);
};


/**
 * repeated FlightDebugFile debug_files = 9;
 * @return {!Array<!proto.flight_deck.FlightDebugFile>}
 */
proto.flight_deck.Flight.prototype.getDebugFilesList = function() {
  return /** @type{!Array<!proto.flight_deck.FlightDebugFile>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.flight_deck.FlightDebugFile, 9));
};


/**
 * @param {!Array<!proto.flight_deck.FlightDebugFile>} value
 * @return {!proto.flight_deck.Flight} returns this
*/
proto.flight_deck.Flight.prototype.setDebugFilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.flight_deck.FlightDebugFile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.FlightDebugFile}
 */
proto.flight_deck.Flight.prototype.addDebugFiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.flight_deck.FlightDebugFile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.clearDebugFilesList = function() {
  return this.setDebugFilesList([]);
};


/**
 * optional IngestStatus ingest_status = 19;
 * @return {!proto.flight_deck.Flight.IngestStatus}
 */
proto.flight_deck.Flight.prototype.getIngestStatus = function() {
  return /** @type {!proto.flight_deck.Flight.IngestStatus} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.flight_deck.Flight.IngestStatus} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setIngestStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional Comment comment = 12;
 * @return {?proto.flight_deck.Comment}
 */
proto.flight_deck.Flight.prototype.getComment = function() {
  return /** @type{?proto.flight_deck.Comment} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_infrastructure_flight_deck_comment_pb.Comment, 12));
};


/**
 * @param {?proto.flight_deck.Comment|undefined} value
 * @return {!proto.flight_deck.Flight} returns this
*/
proto.flight_deck.Flight.prototype.setComment = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.clearComment = function() {
  return this.setComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Flight.prototype.hasComment = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional FlightStats stats = 13;
 * @return {?proto.flight_deck.FlightStats}
 */
proto.flight_deck.Flight.prototype.getStats = function() {
  return /** @type{?proto.flight_deck.FlightStats} */ (
    jspb.Message.getWrapperField(this, proto.flight_deck.FlightStats, 13));
};


/**
 * @param {?proto.flight_deck.FlightStats|undefined} value
 * @return {!proto.flight_deck.Flight} returns this
*/
proto.flight_deck.Flight.prototype.setStats = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.clearStats = function() {
  return this.setStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Flight.prototype.hasStats = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string release_key = 21;
 * @return {string}
 */
proto.flight_deck.Flight.prototype.getReleaseKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setReleaseKey = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string deploy_commit = 22;
 * @return {string}
 */
proto.flight_deck.Flight.prototype.getDeployCommit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setDeployCommit = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional int64 takeoff_flight_deck_run = 28;
 * @return {number}
 */
proto.flight_deck.Flight.prototype.getTakeoffFlightDeckRun = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setTakeoffFlightDeckRun = function(value) {
  return jspb.Message.setProto3IntField(this, 28, value);
};


/**
 * optional int64 landing_flight_deck_run = 29;
 * @return {number}
 */
proto.flight_deck.Flight.prototype.getLandingFlightDeckRun = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setLandingFlightDeckRun = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional cloud_api.LandingResults landing_results = 32;
 * @return {?proto.cloud_api.LandingResults}
 */
proto.flight_deck.Flight.prototype.getLandingResults = function() {
  return /** @type{?proto.cloud_api.LandingResults} */ (
    jspb.Message.getWrapperField(this, pbtypes_tools_cloud_api_landing_results_pb.LandingResults, 32));
};


/**
 * @param {?proto.cloud_api.LandingResults|undefined} value
 * @return {!proto.flight_deck.Flight} returns this
*/
proto.flight_deck.Flight.prototype.setLandingResults = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.clearLandingResults = function() {
  return this.setLandingResults(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Flight.prototype.hasLandingResults = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional string gimbal_id = 34;
 * @return {string}
 */
proto.flight_deck.Flight.prototype.getGimbalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.setGimbalId = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional attachment_manager.VehicleAttachmentInfo vehicle_attachment_info = 35;
 * @return {?proto.attachment_manager.VehicleAttachmentInfo}
 */
proto.flight_deck.Flight.prototype.getVehicleAttachmentInfo = function() {
  return /** @type{?proto.attachment_manager.VehicleAttachmentInfo} */ (
    jspb.Message.getWrapperField(this, pbtypes_infrastructure_drivers_attachment_manager_attachment_manager_pb.VehicleAttachmentInfo, 35));
};


/**
 * @param {?proto.attachment_manager.VehicleAttachmentInfo|undefined} value
 * @return {!proto.flight_deck.Flight} returns this
*/
proto.flight_deck.Flight.prototype.setVehicleAttachmentInfo = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.clearVehicleAttachmentInfo = function() {
  return this.setVehicleAttachmentInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Flight.prototype.hasVehicleAttachmentInfo = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional FlightModemStatesInfo flight_modem_states = 37;
 * @return {?proto.flight_deck.FlightModemStatesInfo}
 */
proto.flight_deck.Flight.prototype.getFlightModemStates = function() {
  return /** @type{?proto.flight_deck.FlightModemStatesInfo} */ (
    jspb.Message.getWrapperField(this, proto.flight_deck.FlightModemStatesInfo, 37));
};


/**
 * @param {?proto.flight_deck.FlightModemStatesInfo|undefined} value
 * @return {!proto.flight_deck.Flight} returns this
*/
proto.flight_deck.Flight.prototype.setFlightModemStates = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Flight} returns this
 */
proto.flight_deck.Flight.prototype.clearFlightModemStates = function() {
  return this.setFlightModemStates(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Flight.prototype.hasFlightModemStates = function() {
  return jspb.Message.getField(this, 37) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.FlightStats.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.FlightStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.FlightStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightStats.toObject = function(includeInstance, msg) {
  var f, obj = {
averageSpeed2d: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
averageSpeed3d: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
topSpeed2d: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
topSpeed3d: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
totalDistance2d: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
totalDistance3d: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.FlightStats}
 */
proto.flight_deck.FlightStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.FlightStats;
  return proto.flight_deck.FlightStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.FlightStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.FlightStats}
 */
proto.flight_deck.FlightStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAverageSpeed2d(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAverageSpeed3d(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTopSpeed2d(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTopSpeed3d(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalDistance2d(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalDistance3d(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.FlightStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.FlightStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.FlightStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAverageSpeed2d();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getAverageSpeed3d();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getTopSpeed2d();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getTopSpeed3d();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getTotalDistance2d();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getTotalDistance3d();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional double average_speed_2d = 1;
 * @return {number}
 */
proto.flight_deck.FlightStats.prototype.getAverageSpeed2d = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.FlightStats} returns this
 */
proto.flight_deck.FlightStats.prototype.setAverageSpeed2d = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double average_speed_3d = 2;
 * @return {number}
 */
proto.flight_deck.FlightStats.prototype.getAverageSpeed3d = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.FlightStats} returns this
 */
proto.flight_deck.FlightStats.prototype.setAverageSpeed3d = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double top_speed_2d = 3;
 * @return {number}
 */
proto.flight_deck.FlightStats.prototype.getTopSpeed2d = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.FlightStats} returns this
 */
proto.flight_deck.FlightStats.prototype.setTopSpeed2d = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double top_speed_3d = 4;
 * @return {number}
 */
proto.flight_deck.FlightStats.prototype.getTopSpeed3d = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.FlightStats} returns this
 */
proto.flight_deck.FlightStats.prototype.setTopSpeed3d = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double total_distance_2d = 5;
 * @return {number}
 */
proto.flight_deck.FlightStats.prototype.getTotalDistance2d = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.FlightStats} returns this
 */
proto.flight_deck.FlightStats.prototype.setTotalDistance2d = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double total_distance_3d = 6;
 * @return {number}
 */
proto.flight_deck.FlightStats.prototype.getTotalDistance3d = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.FlightStats} returns this
 */
proto.flight_deck.FlightStats.prototype.setTotalDistance3d = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_deck.FlightModemStatesInfo.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.FlightModemStatesInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.FlightModemStatesInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.FlightModemStatesInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightModemStatesInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
statesList: jspb.Message.toObjectList(msg.getStatesList(),
    pbtypes_tools_cloud_api_flight_pb.FlightModemState.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.FlightModemStatesInfo}
 */
proto.flight_deck.FlightModemStatesInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.FlightModemStatesInfo;
  return proto.flight_deck.FlightModemStatesInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.FlightModemStatesInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.FlightModemStatesInfo}
 */
proto.flight_deck.FlightModemStatesInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_tools_cloud_api_flight_pb.FlightModemState;
      reader.readMessage(value,pbtypes_tools_cloud_api_flight_pb.FlightModemState.deserializeBinaryFromReader);
      msg.addStates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.FlightModemStatesInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.FlightModemStatesInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.FlightModemStatesInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightModemStatesInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_tools_cloud_api_flight_pb.FlightModemState.serializeBinaryToWriter
    );
  }
};


/**
 * repeated cloud_api.FlightModemState states = 1;
 * @return {!Array<!proto.cloud_api.FlightModemState>}
 */
proto.flight_deck.FlightModemStatesInfo.prototype.getStatesList = function() {
  return /** @type{!Array<!proto.cloud_api.FlightModemState>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_tools_cloud_api_flight_pb.FlightModemState, 1));
};


/**
 * @param {!Array<!proto.cloud_api.FlightModemState>} value
 * @return {!proto.flight_deck.FlightModemStatesInfo} returns this
*/
proto.flight_deck.FlightModemStatesInfo.prototype.setStatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.cloud_api.FlightModemState=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud_api.FlightModemState}
 */
proto.flight_deck.FlightModemStatesInfo.prototype.addStates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.cloud_api.FlightModemState, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.FlightModemStatesInfo} returns this
 */
proto.flight_deck.FlightModemStatesInfo.prototype.clearStatesList = function() {
  return this.setStatesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_deck.Flights.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.Flights.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.Flights.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.Flights} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.Flights.toObject = function(includeInstance, msg) {
  var f, obj = {
flightsList: jspb.Message.toObjectList(msg.getFlightsList(),
    proto.flight_deck.Flight.toObject, includeInstance),
flightInProgress: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
mounted: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
postProcessing: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
highPriorityPostProcessing: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
flightMediaStatusesMap: (f = msg.getFlightMediaStatusesMap()) ? f.toObject(includeInstance, proto.flight_deck.FlightMediaStatus.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.Flights}
 */
proto.flight_deck.Flights.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.Flights;
  return proto.flight_deck.Flights.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.Flights} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.Flights}
 */
proto.flight_deck.Flights.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.flight_deck.Flight;
      reader.readMessage(value,proto.flight_deck.Flight.deserializeBinaryFromReader);
      msg.addFlights(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFlightInProgress(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMounted(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPostProcessing(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHighPriorityPostProcessing(value);
      break;
    case 5:
      var value = msg.getFlightMediaStatusesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.flight_deck.FlightMediaStatus.deserializeBinaryFromReader, "", new proto.flight_deck.FlightMediaStatus());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.Flights.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.Flights.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.Flights} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.Flights.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFlightsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.flight_deck.Flight.serializeBinaryToWriter
    );
  }
  f = message.getFlightInProgress();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMounted();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getPostProcessing();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getHighPriorityPostProcessing();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getFlightMediaStatusesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.flight_deck.FlightMediaStatus.serializeBinaryToWriter);
  }
};


/**
 * repeated Flight flights = 1;
 * @return {!Array<!proto.flight_deck.Flight>}
 */
proto.flight_deck.Flights.prototype.getFlightsList = function() {
  return /** @type{!Array<!proto.flight_deck.Flight>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.flight_deck.Flight, 1));
};


/**
 * @param {!Array<!proto.flight_deck.Flight>} value
 * @return {!proto.flight_deck.Flights} returns this
*/
proto.flight_deck.Flights.prototype.setFlightsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.flight_deck.Flight=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.Flight}
 */
proto.flight_deck.Flights.prototype.addFlights = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.flight_deck.Flight, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.Flights} returns this
 */
proto.flight_deck.Flights.prototype.clearFlightsList = function() {
  return this.setFlightsList([]);
};


/**
 * optional bool flight_in_progress = 2;
 * @return {boolean}
 */
proto.flight_deck.Flights.prototype.getFlightInProgress = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.Flights} returns this
 */
proto.flight_deck.Flights.prototype.setFlightInProgress = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool mounted = 3;
 * @return {boolean}
 */
proto.flight_deck.Flights.prototype.getMounted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.Flights} returns this
 */
proto.flight_deck.Flights.prototype.setMounted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool post_processing = 4;
 * @return {boolean}
 */
proto.flight_deck.Flights.prototype.getPostProcessing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.Flights} returns this
 */
proto.flight_deck.Flights.prototype.setPostProcessing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool high_priority_post_processing = 6;
 * @return {boolean}
 */
proto.flight_deck.Flights.prototype.getHighPriorityPostProcessing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.Flights} returns this
 */
proto.flight_deck.Flights.prototype.setHighPriorityPostProcessing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * map<string, FlightMediaStatus> flight_media_statuses = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.flight_deck.FlightMediaStatus>}
 */
proto.flight_deck.Flights.prototype.getFlightMediaStatusesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.flight_deck.FlightMediaStatus>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.flight_deck.FlightMediaStatus));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.flight_deck.Flights} returns this
 */
proto.flight_deck.Flights.prototype.clearFlightMediaStatusesMap = function() {
  this.getFlightMediaStatusesMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_deck.FlightMediaStatus.repeatedFields_ = [4,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.FlightMediaStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.FlightMediaStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.FlightMediaStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightMediaStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
flight: (f = msg.getFlight()) && proto.flight_deck.Flight.toObject(includeInstance, f),
editorReadiness: jspb.Message.getFieldWithDefault(msg, 3, 0),
alignedAudioProgressList: jspb.Message.toObjectList(msg.getAlignedAudioProgressList(),
    proto.flight_deck.FlightMediaStatus.MediaProgress.toObject, includeInstance),
missingAudioList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.FlightMediaStatus}
 */
proto.flight_deck.FlightMediaStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.FlightMediaStatus;
  return proto.flight_deck.FlightMediaStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.FlightMediaStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.FlightMediaStatus}
 */
proto.flight_deck.FlightMediaStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.flight_deck.Flight;
      reader.readMessage(value,proto.flight_deck.Flight.deserializeBinaryFromReader);
      msg.setFlight(value);
      break;
    case 3:
      var value = /** @type {!proto.flight_deck.FlightMediaStatus.EditorReadiness.Type} */ (reader.readEnum());
      msg.setEditorReadiness(value);
      break;
    case 4:
      var value = new proto.flight_deck.FlightMediaStatus.MediaProgress;
      reader.readMessage(value,proto.flight_deck.FlightMediaStatus.MediaProgress.deserializeBinaryFromReader);
      msg.addAlignedAudioProgress(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addMissingAudio(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.FlightMediaStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.FlightMediaStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.FlightMediaStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightMediaStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFlight();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.flight_deck.Flight.serializeBinaryToWriter
    );
  }
  f = message.getEditorReadiness();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getAlignedAudioProgressList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.flight_deck.FlightMediaStatus.MediaProgress.serializeBinaryToWriter
    );
  }
  f = message.getMissingAudioList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.FlightMediaStatus.MediaProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.FlightMediaStatus.MediaProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
mediaId: jspb.Message.getFieldWithDefault(msg, 1, ""),
progress: jspb.Message.getFieldWithDefault(msg, 2, 0),
downloadUri: jspb.Message.getFieldWithDefault(msg, 3, ""),
progressFraction: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.FlightMediaStatus.MediaProgress}
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.FlightMediaStatus.MediaProgress;
  return proto.flight_deck.FlightMediaStatus.MediaProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.FlightMediaStatus.MediaProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.FlightMediaStatus.MediaProgress}
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMediaId(value);
      break;
    case 2:
      var value = /** @type {!proto.flight_deck.FlightMediaStatus.MediaProgress.Type} */ (reader.readEnum());
      msg.setProgress(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadUri(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setProgressFraction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.FlightMediaStatus.MediaProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.FlightMediaStatus.MediaProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMediaId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProgress();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDownloadUri();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProgressFraction();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.Type = {
  UNKNOWN: 0,
  NO_PROMISE: 1,
  QUEUED: 2,
  IN_PROGRESS: 3,
  AVAILABLE: 4,
  FAILED: 5
};

/**
 * optional string media_id = 1;
 * @return {string}
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.prototype.getMediaId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.FlightMediaStatus.MediaProgress} returns this
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.prototype.setMediaId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Type progress = 2;
 * @return {!proto.flight_deck.FlightMediaStatus.MediaProgress.Type}
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.prototype.getProgress = function() {
  return /** @type {!proto.flight_deck.FlightMediaStatus.MediaProgress.Type} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.flight_deck.FlightMediaStatus.MediaProgress.Type} value
 * @return {!proto.flight_deck.FlightMediaStatus.MediaProgress} returns this
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.prototype.setProgress = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string download_uri = 3;
 * @return {string}
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.prototype.getDownloadUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.FlightMediaStatus.MediaProgress} returns this
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.prototype.setDownloadUri = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional float progress_fraction = 4;
 * @return {number}
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.prototype.getProgressFraction = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.FlightMediaStatus.MediaProgress} returns this
 */
proto.flight_deck.FlightMediaStatus.MediaProgress.prototype.setProgressFraction = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.FlightMediaStatus.EditorReadiness.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.FlightMediaStatus.EditorReadiness.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.FlightMediaStatus.EditorReadiness} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightMediaStatus.EditorReadiness.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.FlightMediaStatus.EditorReadiness}
 */
proto.flight_deck.FlightMediaStatus.EditorReadiness.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.FlightMediaStatus.EditorReadiness;
  return proto.flight_deck.FlightMediaStatus.EditorReadiness.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.FlightMediaStatus.EditorReadiness} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.FlightMediaStatus.EditorReadiness}
 */
proto.flight_deck.FlightMediaStatus.EditorReadiness.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.FlightMediaStatus.EditorReadiness.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.FlightMediaStatus.EditorReadiness.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.FlightMediaStatus.EditorReadiness} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightMediaStatus.EditorReadiness.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.flight_deck.FlightMediaStatus.EditorReadiness.Type = {
  UNKNOWN: 0,
  WAITING_FOR_FULL_RES_VIDEO: 1,
  WAITING_FOR_AUDIO_UPLOAD: 2,
  WAITING_TO_ALIGN_AUDIO: 3,
  ALIGNING_AUDIO: 4,
  WAITING_FOR_TRANSCODE_READINESS: 8,
  READY_WITHOUT_AUDIO: 5,
  READY_WITH_AUDIO: 6,
  IMPOSSIBLE_NO_FULL_RES_VIDEO: 7
};

/**
 * optional Flight flight = 1;
 * @return {?proto.flight_deck.Flight}
 */
proto.flight_deck.FlightMediaStatus.prototype.getFlight = function() {
  return /** @type{?proto.flight_deck.Flight} */ (
    jspb.Message.getWrapperField(this, proto.flight_deck.Flight, 1));
};


/**
 * @param {?proto.flight_deck.Flight|undefined} value
 * @return {!proto.flight_deck.FlightMediaStatus} returns this
*/
proto.flight_deck.FlightMediaStatus.prototype.setFlight = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.FlightMediaStatus} returns this
 */
proto.flight_deck.FlightMediaStatus.prototype.clearFlight = function() {
  return this.setFlight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.FlightMediaStatus.prototype.hasFlight = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EditorReadiness.Type editor_readiness = 3;
 * @return {!proto.flight_deck.FlightMediaStatus.EditorReadiness.Type}
 */
proto.flight_deck.FlightMediaStatus.prototype.getEditorReadiness = function() {
  return /** @type {!proto.flight_deck.FlightMediaStatus.EditorReadiness.Type} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.flight_deck.FlightMediaStatus.EditorReadiness.Type} value
 * @return {!proto.flight_deck.FlightMediaStatus} returns this
 */
proto.flight_deck.FlightMediaStatus.prototype.setEditorReadiness = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated MediaProgress aligned_audio_progress = 4;
 * @return {!Array<!proto.flight_deck.FlightMediaStatus.MediaProgress>}
 */
proto.flight_deck.FlightMediaStatus.prototype.getAlignedAudioProgressList = function() {
  return /** @type{!Array<!proto.flight_deck.FlightMediaStatus.MediaProgress>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.flight_deck.FlightMediaStatus.MediaProgress, 4));
};


/**
 * @param {!Array<!proto.flight_deck.FlightMediaStatus.MediaProgress>} value
 * @return {!proto.flight_deck.FlightMediaStatus} returns this
*/
proto.flight_deck.FlightMediaStatus.prototype.setAlignedAudioProgressList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.flight_deck.FlightMediaStatus.MediaProgress=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.FlightMediaStatus.MediaProgress}
 */
proto.flight_deck.FlightMediaStatus.prototype.addAlignedAudioProgress = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.flight_deck.FlightMediaStatus.MediaProgress, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.FlightMediaStatus} returns this
 */
proto.flight_deck.FlightMediaStatus.prototype.clearAlignedAudioProgressList = function() {
  return this.setAlignedAudioProgressList([]);
};


/**
 * repeated string missing_audio = 6;
 * @return {!Array<string>}
 */
proto.flight_deck.FlightMediaStatus.prototype.getMissingAudioList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.flight_deck.FlightMediaStatus} returns this
 */
proto.flight_deck.FlightMediaStatus.prototype.setMissingAudioList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.FlightMediaStatus} returns this
 */
proto.flight_deck.FlightMediaStatus.prototype.addMissingAudio = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.FlightMediaStatus} returns this
 */
proto.flight_deck.FlightMediaStatus.prototype.clearMissingAudioList = function() {
  return this.setMissingAudioList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.FlightLogDirUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.FlightLogDirUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.FlightLogDirUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightLogDirUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
flightId: jspb.Message.getFieldWithDefault(msg, 1, ""),
logDir: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.FlightLogDirUpdate}
 */
proto.flight_deck.FlightLogDirUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.FlightLogDirUpdate;
  return proto.flight_deck.FlightLogDirUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.FlightLogDirUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.FlightLogDirUpdate}
 */
proto.flight_deck.FlightLogDirUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlightId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogDir(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.FlightLogDirUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.FlightLogDirUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.FlightLogDirUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightLogDirUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFlightId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLogDir();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string flight_id = 1;
 * @return {string}
 */
proto.flight_deck.FlightLogDirUpdate.prototype.getFlightId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.FlightLogDirUpdate} returns this
 */
proto.flight_deck.FlightLogDirUpdate.prototype.setFlightId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string log_dir = 2;
 * @return {string}
 */
proto.flight_deck.FlightLogDirUpdate.prototype.getLogDir = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.FlightLogDirUpdate} returns this
 */
proto.flight_deck.FlightLogDirUpdate.prototype.setLogDir = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.FlightLogTruncateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.FlightLogTruncateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.FlightLogTruncateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightLogTruncateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
flightId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.FlightLogTruncateRequest}
 */
proto.flight_deck.FlightLogTruncateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.FlightLogTruncateRequest;
  return proto.flight_deck.FlightLogTruncateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.FlightLogTruncateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.FlightLogTruncateRequest}
 */
proto.flight_deck.FlightLogTruncateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlightId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.FlightLogTruncateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.FlightLogTruncateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.FlightLogTruncateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightLogTruncateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFlightId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string flight_id = 1;
 * @return {string}
 */
proto.flight_deck.FlightLogTruncateRequest.prototype.getFlightId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.FlightLogTruncateRequest} returns this
 */
proto.flight_deck.FlightLogTruncateRequest.prototype.setFlightId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_deck.FlightFailures.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.FlightFailures.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.FlightFailures.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.FlightFailures} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightFailures.toObject = function(includeInstance, msg) {
  var f, obj = {
failureModesList: jspb.Message.toObjectList(msg.getFailureModesList(),
    proto.flight_deck.FlightFailureMode.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.FlightFailures}
 */
proto.flight_deck.FlightFailures.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.FlightFailures;
  return proto.flight_deck.FlightFailures.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.FlightFailures} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.FlightFailures}
 */
proto.flight_deck.FlightFailures.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.flight_deck.FlightFailureMode;
      reader.readMessage(value,proto.flight_deck.FlightFailureMode.deserializeBinaryFromReader);
      msg.addFailureModes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.FlightFailures.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.FlightFailures.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.FlightFailures} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightFailures.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFailureModesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.flight_deck.FlightFailureMode.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FlightFailureMode failure_modes = 1;
 * @return {!Array<!proto.flight_deck.FlightFailureMode>}
 */
proto.flight_deck.FlightFailures.prototype.getFailureModesList = function() {
  return /** @type{!Array<!proto.flight_deck.FlightFailureMode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.flight_deck.FlightFailureMode, 1));
};


/**
 * @param {!Array<!proto.flight_deck.FlightFailureMode>} value
 * @return {!proto.flight_deck.FlightFailures} returns this
*/
proto.flight_deck.FlightFailures.prototype.setFailureModesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.flight_deck.FlightFailureMode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.FlightFailureMode}
 */
proto.flight_deck.FlightFailures.prototype.addFailureModes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.flight_deck.FlightFailureMode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.FlightFailures} returns this
 */
proto.flight_deck.FlightFailures.prototype.clearFailureModesList = function() {
  return this.setFailureModesList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.flight_deck.FlightFailureMode.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.flight_deck.FlightFailureMode.ModesCase = {
  MODES_NOT_SET: 0,
  FAILED_MISSION: 1,
  FAULTS: 2
};

/**
 * @return {proto.flight_deck.FlightFailureMode.ModesCase}
 */
proto.flight_deck.FlightFailureMode.prototype.getModesCase = function() {
  return /** @type {proto.flight_deck.FlightFailureMode.ModesCase} */(jspb.Message.computeOneofCase(this, proto.flight_deck.FlightFailureMode.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.FlightFailureMode.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.FlightFailureMode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.FlightFailureMode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightFailureMode.toObject = function(includeInstance, msg) {
  var f, obj = {
failedMission: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
faults: (f = msg.getFaults()) && proto.flight_deck.FlightFaults.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.FlightFailureMode}
 */
proto.flight_deck.FlightFailureMode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.FlightFailureMode;
  return proto.flight_deck.FlightFailureMode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.FlightFailureMode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.FlightFailureMode}
 */
proto.flight_deck.FlightFailureMode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFailedMission(value);
      break;
    case 2:
      var value = new proto.flight_deck.FlightFaults;
      reader.readMessage(value,proto.flight_deck.FlightFaults.deserializeBinaryFromReader);
      msg.setFaults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.FlightFailureMode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.FlightFailureMode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.FlightFailureMode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightFailureMode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {boolean} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getFaults();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.flight_deck.FlightFaults.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool failed_mission = 1;
 * @return {boolean}
 */
proto.flight_deck.FlightFailureMode.prototype.getFailedMission = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.FlightFailureMode} returns this
 */
proto.flight_deck.FlightFailureMode.prototype.setFailedMission = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.flight_deck.FlightFailureMode.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.flight_deck.FlightFailureMode} returns this
 */
proto.flight_deck.FlightFailureMode.prototype.clearFailedMission = function() {
  return jspb.Message.setOneofField(this, 1, proto.flight_deck.FlightFailureMode.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.FlightFailureMode.prototype.hasFailedMission = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FlightFaults faults = 2;
 * @return {?proto.flight_deck.FlightFaults}
 */
proto.flight_deck.FlightFailureMode.prototype.getFaults = function() {
  return /** @type{?proto.flight_deck.FlightFaults} */ (
    jspb.Message.getWrapperField(this, proto.flight_deck.FlightFaults, 2));
};


/**
 * @param {?proto.flight_deck.FlightFaults|undefined} value
 * @return {!proto.flight_deck.FlightFailureMode} returns this
*/
proto.flight_deck.FlightFailureMode.prototype.setFaults = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.flight_deck.FlightFailureMode.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.FlightFailureMode} returns this
 */
proto.flight_deck.FlightFailureMode.prototype.clearFaults = function() {
  return this.setFaults(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.FlightFailureMode.prototype.hasFaults = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_deck.FlightFaults.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.FlightFaults.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.FlightFaults.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.FlightFaults} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightFaults.toObject = function(includeInstance, msg) {
  var f, obj = {
faultIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.FlightFaults}
 */
proto.flight_deck.FlightFaults.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.FlightFaults;
  return proto.flight_deck.FlightFaults.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.FlightFaults} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.FlightFaults}
 */
proto.flight_deck.FlightFaults.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addFaultIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.FlightFaults.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.FlightFaults.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.FlightFaults} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.FlightFaults.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFaultIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 fault_ids = 1;
 * @return {!Array<number>}
 */
proto.flight_deck.FlightFaults.prototype.getFaultIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.flight_deck.FlightFaults} returns this
 */
proto.flight_deck.FlightFaults.prototype.setFaultIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.FlightFaults} returns this
 */
proto.flight_deck.FlightFaults.prototype.addFaultIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.FlightFaults} returns this
 */
proto.flight_deck.FlightFaults.prototype.clearFaultIdsList = function() {
  return this.setFaultIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.LogDeletionPolicy.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.LogDeletionPolicy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.LogDeletionPolicy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.LogDeletionPolicy.toObject = function(includeInstance, msg) {
  var f, obj = {
flightId: jspb.Message.getFieldWithDefault(msg, 1, ""),
preventDeletion: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.LogDeletionPolicy}
 */
proto.flight_deck.LogDeletionPolicy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.LogDeletionPolicy;
  return proto.flight_deck.LogDeletionPolicy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.LogDeletionPolicy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.LogDeletionPolicy}
 */
proto.flight_deck.LogDeletionPolicy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlightId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPreventDeletion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.LogDeletionPolicy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.LogDeletionPolicy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.LogDeletionPolicy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.LogDeletionPolicy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFlightId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPreventDeletion();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string flight_id = 1;
 * @return {string}
 */
proto.flight_deck.LogDeletionPolicy.prototype.getFlightId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.LogDeletionPolicy} returns this
 */
proto.flight_deck.LogDeletionPolicy.prototype.setFlightId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool prevent_deletion = 2;
 * @return {boolean}
 */
proto.flight_deck.LogDeletionPolicy.prototype.getPreventDeletion = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.LogDeletionPolicy} returns this
 */
proto.flight_deck.LogDeletionPolicy.prototype.setPreventDeletion = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_deck.UpdateLogDeletionPolicyRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.UpdateLogDeletionPolicyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.UpdateLogDeletionPolicyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.UpdateLogDeletionPolicyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.UpdateLogDeletionPolicyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
policiesList: jspb.Message.toObjectList(msg.getPoliciesList(),
    proto.flight_deck.LogDeletionPolicy.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.UpdateLogDeletionPolicyRequest}
 */
proto.flight_deck.UpdateLogDeletionPolicyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.UpdateLogDeletionPolicyRequest;
  return proto.flight_deck.UpdateLogDeletionPolicyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.UpdateLogDeletionPolicyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.UpdateLogDeletionPolicyRequest}
 */
proto.flight_deck.UpdateLogDeletionPolicyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.flight_deck.LogDeletionPolicy;
      reader.readMessage(value,proto.flight_deck.LogDeletionPolicy.deserializeBinaryFromReader);
      msg.addPolicies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.UpdateLogDeletionPolicyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.UpdateLogDeletionPolicyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.UpdateLogDeletionPolicyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.UpdateLogDeletionPolicyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPoliciesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.flight_deck.LogDeletionPolicy.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LogDeletionPolicy policies = 1;
 * @return {!Array<!proto.flight_deck.LogDeletionPolicy>}
 */
proto.flight_deck.UpdateLogDeletionPolicyRequest.prototype.getPoliciesList = function() {
  return /** @type{!Array<!proto.flight_deck.LogDeletionPolicy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.flight_deck.LogDeletionPolicy, 1));
};


/**
 * @param {!Array<!proto.flight_deck.LogDeletionPolicy>} value
 * @return {!proto.flight_deck.UpdateLogDeletionPolicyRequest} returns this
*/
proto.flight_deck.UpdateLogDeletionPolicyRequest.prototype.setPoliciesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.flight_deck.LogDeletionPolicy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.LogDeletionPolicy}
 */
proto.flight_deck.UpdateLogDeletionPolicyRequest.prototype.addPolicies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.flight_deck.LogDeletionPolicy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.UpdateLogDeletionPolicyRequest} returns this
 */
proto.flight_deck.UpdateLogDeletionPolicyRequest.prototype.clearPoliciesList = function() {
  return this.setPoliciesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.UpdateLogDeletionPolicyResult.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.UpdateLogDeletionPolicyResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.UpdateLogDeletionPolicyResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.UpdateLogDeletionPolicyResult.toObject = function(includeInstance, msg) {
  var f, obj = {
flightId: jspb.Message.getFieldWithDefault(msg, 1, ""),
result: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.UpdateLogDeletionPolicyResult}
 */
proto.flight_deck.UpdateLogDeletionPolicyResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.UpdateLogDeletionPolicyResult;
  return proto.flight_deck.UpdateLogDeletionPolicyResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.UpdateLogDeletionPolicyResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.UpdateLogDeletionPolicyResult}
 */
proto.flight_deck.UpdateLogDeletionPolicyResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlightId(value);
      break;
    case 2:
      var value = /** @type {!proto.flight_deck.UpdateLogDeletionPolicyResult.Result} */ (reader.readEnum());
      msg.setResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.UpdateLogDeletionPolicyResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.UpdateLogDeletionPolicyResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.UpdateLogDeletionPolicyResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.UpdateLogDeletionPolicyResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFlightId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.flight_deck.UpdateLogDeletionPolicyResult.Result = {
  UNKNOWN: 0,
  SUCCESS: 1,
  MAX_FLIGHTS_EXCEEDED: 2,
  UNKNOWN_FLIGHT_ID: 3
};

/**
 * optional string flight_id = 1;
 * @return {string}
 */
proto.flight_deck.UpdateLogDeletionPolicyResult.prototype.getFlightId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.UpdateLogDeletionPolicyResult} returns this
 */
proto.flight_deck.UpdateLogDeletionPolicyResult.prototype.setFlightId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Result result = 2;
 * @return {!proto.flight_deck.UpdateLogDeletionPolicyResult.Result}
 */
proto.flight_deck.UpdateLogDeletionPolicyResult.prototype.getResult = function() {
  return /** @type {!proto.flight_deck.UpdateLogDeletionPolicyResult.Result} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.flight_deck.UpdateLogDeletionPolicyResult.Result} value
 * @return {!proto.flight_deck.UpdateLogDeletionPolicyResult} returns this
 */
proto.flight_deck.UpdateLogDeletionPolicyResult.prototype.setResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_deck.UpdateLogDeletionPolicyResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.UpdateLogDeletionPolicyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.UpdateLogDeletionPolicyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.UpdateLogDeletionPolicyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.UpdateLogDeletionPolicyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.flight_deck.UpdateLogDeletionPolicyResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.UpdateLogDeletionPolicyResponse}
 */
proto.flight_deck.UpdateLogDeletionPolicyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.UpdateLogDeletionPolicyResponse;
  return proto.flight_deck.UpdateLogDeletionPolicyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.UpdateLogDeletionPolicyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.UpdateLogDeletionPolicyResponse}
 */
proto.flight_deck.UpdateLogDeletionPolicyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.flight_deck.UpdateLogDeletionPolicyResult;
      reader.readMessage(value,proto.flight_deck.UpdateLogDeletionPolicyResult.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.UpdateLogDeletionPolicyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.UpdateLogDeletionPolicyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.UpdateLogDeletionPolicyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.UpdateLogDeletionPolicyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.flight_deck.UpdateLogDeletionPolicyResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UpdateLogDeletionPolicyResult results = 1;
 * @return {!Array<!proto.flight_deck.UpdateLogDeletionPolicyResult>}
 */
proto.flight_deck.UpdateLogDeletionPolicyResponse.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.flight_deck.UpdateLogDeletionPolicyResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.flight_deck.UpdateLogDeletionPolicyResult, 1));
};


/**
 * @param {!Array<!proto.flight_deck.UpdateLogDeletionPolicyResult>} value
 * @return {!proto.flight_deck.UpdateLogDeletionPolicyResponse} returns this
*/
proto.flight_deck.UpdateLogDeletionPolicyResponse.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.flight_deck.UpdateLogDeletionPolicyResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.UpdateLogDeletionPolicyResult}
 */
proto.flight_deck.UpdateLogDeletionPolicyResponse.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.flight_deck.UpdateLogDeletionPolicyResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.UpdateLogDeletionPolicyResponse} returns this
 */
proto.flight_deck.UpdateLogDeletionPolicyResponse.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};


goog.object.extend(exports, proto.flight_deck);
